export default "__VITE_ASSET__890ffd42__"